var FormBuilderErrors = {

  helper_template: function (errors) {
    var err = [];

    if (errors && errors.helper_template && errors.helper_template.length) {
      for (var i = 0, ilen = errors.helper_template.length; i < ilen; i++) {
        err.push(I18n.t('helper_template') + ' ' + errors.helper_template[i]);
      }
    }  

    // nested errors
    if (errors && ObjectHelper.size(errors) > 0){
      for (var i in errors) {
        if (i.indexOf('helper_template\.') != -1) {
          var base_field = i.split('\.')[1];
          err.push(I18n.t(base_field) + ' ' + errors[i]);
        }
      }
    }

    return err;    
  },

  renderErrors: function (errors) {
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  },

  renderGeneralErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  renderFormFieldErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  generalErrors: function (errors) {
    var err = [];
    if (!errors) {
      return err;
    }
    if (errors.title && errors.title.length) {
      for (var i = 0, ilen = errors.title.length; i < ilen; i++) {
        err.push(I18n.t('title') + ' ' + errors.title[i]);
      }
    }
    if (errors.header_errors && errors.header_errors.length) {
      for (var i = 0, ilen = errors.header_errors.length; i < ilen; i++) {
        err.push(I18n.t('status') + ' ' + errors.header_errors[i]);
      }
    }
    return err;
  },

  formFieldErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.form_fields && errors.form_fields.length) {
      for (var i = 0, ilen = errors.form_fields.length; i < ilen; i++) {
        err.push(I18n.t('form_fields') + ' ' + errors.form_fields[i]);

      }
    }
    
    return err;
  },

};

export default FormBuilderErrors